import React from 'react';

function Layout(props) {
  let animationClass = props.bgClass ? `animation-covid ${props.bgClass}` : 'animation-covid';
  return (
    <div id="wrapper" className="covid">
      <div className={animationClass}>
        <ul>
          <li></li>
          <li></li>
        </ul>
        <div className="page-cover"></div>
      </div>
      <div className="page-main">
        {props.children}
      </div>
    </div>
  );
}

export default Layout;